module.exports = __webpack_public_path__ + "media/images/pages/img_culture_area_01-feeabc992654a57889aa7663b4522026.jpg";